import React, { useRef, useEffect, useState } from 'react';
import Menu from '../../../components/Menu';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import Swal from 'sweetalert2'
import _ from 'lodash';
import Modal from './Modal';
import parse from 'html-react-parser';
import { buscaTransmissao, verificaTransmissao, criaTransmissaoUser, criaPix, buscaPagamento, buscaInformacoes, auditoria, listaUsuarios, listaSalaVip, listaSalaVipConvidados, deletaSalaVip, criaSalaVipConvidado, buscaCupom, criaPagamentoFree, buscaAtletaIndicacaoEvento } from '../../../services/mysql'
import ModalPix from './ModalPix';
import UsuarioSelect from './UsuarioSelect';
import InputMask from 'react-input-mask';
import { cpf } from 'cpf-cnpj-validator';

export default function Videos() {
    const queryParams = new URLSearchParams(window.location.search);
    const [id] = useState(queryParams.get('i'))
    const [academia] = useState(queryParams.get('a'))
    const [transmissao, setTransmissão] = useState({})
    const [usuarios, setUsuarios] = useState([])
    const [usuario, setUsuario] = useState({})

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const [isModalOpenPix, setIsModalOpenPix] = useState(false);
    const openModalPix = () => setIsModalOpenPix(true);
    const closeModalPix = () => setIsModalOpenPix(false);
    const [salaVip, setSalaVip] = useState([])

    const [termo, setTermo] = useState('')

    const [urlVideo, setUrlVideo] = useState('')
    const [modalVideo, setModalVideo] = useState(false)
    const [qtdConvidados, setQtdConvidados] = useState(0)
    const [cupom, setCupom] = useState('')
    const [idCupom, setIdCupom] = useState('')
    const [desconto, setDeconto] = useState(0)
    const [cpfIndicacao, setCpfIndicacao] = useState('')
    const [atletaIndicacao, setAtletaIndicacao] = useState(null)
    const [mensagemIndicacao, setMensagemIndicacao] = useState('')
    const [buscandoIndicacao, setBuscandoIndicacao] = useState(false)

    // Pagamento
    const [qrcode, setQrcode] = useState('')
    const [copiaCola, setCopiaCola] = useState('')
    const [contador, setContador] = useState(0)
    const intervalId = useRef(null);
    const isMobile = window.innerWidth <= 768;


    useEffect(() => {
        mensagemLoading('Buscando Dados dd...')
        const user = JSON.parse(localStorage.getItem('userd7'))
        buscaTransmissao(id).then((res) => {
            if (res.erro) {
                Swal.close()
                mensagemErro('Erro ao buscar vídeos')
            } else {
                Swal.close()
                setTransmissão(res.transmissao)
                const data = {
                    idUsuario: user.id,
                    acao: 'Acessou a página de Transmissão ' + res.transmissao.nome
                }
                auditoria(data);
                listaSalaVipConvidados(
                    { idUser: user.id, idSala: res.transmissao.id, tipo: 'transmissao' }
                ).then((res) => {
                    if (res.erro) {
                        mensagemErro('Erro ao buscar usuarios')
                    } else {
                        setQtdConvidados(res.qtdConvidados)
                        setSalaVip(res.convidados)
                    }
                })
            }
        })
        listaUsuarios().then((res) => {
            if (res.erro) {
                mensagemErro('Erro ao buscar usuarios')
            } else {
                setUsuarios(res)
            }
        })
        buscaInformacoes().then((res) => {
            if (res.erro) {
                Swal.close()
                mensagemErro('Erro ao buscar Informações')
            } else {
                Swal.close()
                setTermo(res[0].termo)
            }
        })
    }, [])

    const startApiCalls = (pagamento, transmissao) => {
        fetchApiData(pagamento, transmissao);
        intervalId.current = setInterval(() => {
            fetchApiData(pagamento, transmissao);
        }, 10000);
    };

    const fetchApiData = async (pagamento, transmissao) => {
        try {
            buscaPagamento(pagamento).then((res) => {
                if (res.status === 'approved') {
                    const user = JSON.parse(localStorage.getItem('userd7'))
                    const data = {
                        idTransmissao: id,
                        idUser: user.id
                    }
                    criaTransmissaoUser(data).then((resTransmissao) => {
                        if (resTransmissao.erro) {
                            mensagemErro('Erro ao gerar transmissaão')
                            const data = {
                                idUsuario: user.id,
                                acao: 'O sistema mostrou erro no pagamento ' + transmissao.nome
                            }
                            auditoria(data);
                        } else {
                            closeModalPix()
                            setUrlVideo(transmissao.canalTransmissao)
                            // openModal()
                            setModalVideo(true)
                            Swal.close()
                            const data = {
                                idUsuario: user.id,
                                acao: 'O sistema aprovou o pagamento e abriu o vídeo para assistir a transmissão ' + transmissao.nome
                            }
                            auditoria(data);
                        }
                    })
                    clearInterval(intervalId.current);
                }
            });
        } catch (err) {
            mensagemErro('Erro ao realizar pagamento');
        }
    };

    function getPlayerUrl(number) {
        const playerLinks = {
            1: "https://delaysp01.logicahost.com.br:5443/tvcompate/play.html?id=tvcombate",
            2: "https://player.logicahost.com.br/player.php?player=1859",
            3: "https://player.logicahost.com.br/player.php?player=1898",
            4: "https://player.logicahost.com.br/player.php?player=1899",
        };

        return playerLinks[number] || null;
    }

    function realizaTransmissao() {
        const user = JSON.parse(localStorage.getItem('userd7'))
        const data = {
            idUsuario: user.id,
            acao: 'Clicou em detalhar a transmissão ' + transmissao.nome
        }
        auditoria(data);
        mensagemLoading('Verificando..')
        verificaTransmissao(user.id, id).then((res) => {
            if (res.erro) {
                mensagemErro('Erro ao verificar transmissao')
                const data = {
                    idUsuario: user.id,
                    acao: 'Gerou erro ao acessar a transmissão ' + transmissao.nome
                }
                auditoria(data);
            } else {
                if (res.transmissao || res.salaVip) {
                    Swal.close()
                    setUrlVideo(transmissao.canalTransmissao)
                    console.log(transmissao)
                    setModalVideo(true)
                    const data = {
                        idUsuario: user.id,
                        acao: 'Acessou a transmissão ' + transmissao.nome + ' pelo canal ' + transmissao.canalTransmissao
                    }
                    auditoria(data);
                } else if (transmissao.free === 'SIM') {
                    const dados = {
                        id_usuario: user.id,
                        id_video: transmissao.id,
                        nome: 'TVCombate - Transmissão',
                        cpf: user.cpf,
                        email: user.email,
                        descricao: 'Transmissao - ' + transmissao.nome,
                        idCupom: null,
                        desconto: parseFloat(0),
                        valor: parseFloat(0),
                        tipo_video: 'transmissao'
                    }
                    criaPagamentoFree(dados).then((res) => {
                        if (res.erro) {
                            mensagemErro('Erro ao entrar na sala')
                        } else {
                            Swal.close()
                            setUrlVideo(transmissao.canalTransmissao)
                            setModalVideo(true)
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Aviso',
                        text: 'Você precisa realizar o pagamento de ' + (transmissao.valor - parseFloat(desconto)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) + ' para assistir a transmissão ' + transmissao.nome + '! Deseja realizar o pagamento?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Pagar',
                        cancelButtonText: 'Agora Não'
                    }).then((result) => {
                        if (result.value) {
                            const dados = {
                                id_usuario: user.id,
                                id_video: transmissao.id,
                                nome: 'TVCombate - Transmissão',
                                cpf: user.cpf,
                                email: user.email,
                                descricao: 'Transmissao - ' + transmissao.nome,
                                idCupom: idCupom,
                                desconto: parseFloat(desconto),
                                valor: parseFloat(transmissao.valor - parseFloat(desconto)),
                                tipo_video: 'transmissao',
                                indicacao: (transmissao.indicacoes === true || Number(transmissao.indicacoes) === 1) ? atletaIndicacao?.idIndicacao ?? null : null
                            }
                            mensagemLoading('Gerando pix..')
                            criaPix(dados).then((res) => {
                                if (res.erro || !res.data) {
                                    mensagemErro(res.message || res.msg || 'Não foi possível gerar o Pix. Tente novamente.');
                                    return;
                                }
                                if (Number(res.data.indicacao || 0) !== Number(dados.indicacao || 0)) {
                                    setAtletaIndicacao(null);
                                    setMensagemIndicacao('Este Pix já havia sido gerado. A indicação original do pagamento foi mantida.');
                                }
                                setContador(res.data.minutosRestantes)
                                setQrcode(res.data.pagamento.qrcode)
                                setCopiaCola(res.data.pagamento.chave)
                                Swal.close()
                                startApiCalls(res.data.id, transmissao)
                                openModalPix()
                                const data = {
                                    idUsuario: user.id,
                                    acao: 'Gerou o pix da transmissão ' + transmissao.nome
                                }
                                auditoria(data);
                            }).catch(() => mensagemErro('Não foi possível gerar o Pix. Tente novamente.'))
                        }
                    });
                }
            }
        })
    }

    function transmissaoFree() {
        const user = JSON.parse(localStorage.getItem('userd7'))
        const data = {
            idUsuario: user.id,
            acao: 'Clicou em detalhar a transmissão ' + transmissao.nome
        }
        auditoria(data);
        mensagemLoading('Verificando..')
        verificaTransmissao(user.id, id).then((res) => {
            if (res.erro) {
                mensagemErro('Erro ao verificar transmissao')
                const data = {
                    idUsuario: user.id,
                    acao: 'Gerou erro ao acessar a transmissão ' + transmissao.nome
                }
                auditoria(data);
            } else {
                if (res.transmissao || res.salaVip) {
                    Swal.close()
                    setUrlVideo(transmissao.canalTransmissao)
                    console.log(transmissao)
                    // openModal()
                    setModalVideo(true)
                    const data = {
                        idUsuario: user.id,
                        acao: 'Acessou a transmissão ' + transmissao.nome + ' pelo canal ' + transmissao.canalTransmissao
                    }
                    auditoria(data);
                } else {
                    Swal.fire({
                        title: 'Aviso',
                        text: 'Você precisa realizar o pagamento de ' + (transmissao.valor - parseFloat(desconto)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) + ' para assistir a transmissão ' + transmissao.nome + '! Deseja realizar o pagamento?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Pagar',
                        cancelButtonText: 'Agora Não'
                    }).then((result) => {
                        if (result.value) {
                            const dados = {
                                id_usuario: user.id,
                                id_video: transmissao.id,
                                nome: 'TVCombate - Transmissão',
                                cpf: user.cpf,
                                email: user.email,
                                descricao: 'Transmissao - ' + transmissao.nome,
                                idCupom: idCupom,
                                desconto: parseFloat(desconto),
                                valor: parseFloat(transmissao.valor - parseFloat(desconto)),
                                tipo_video: 'transmissao',
                                indicacao: (transmissao.indicacoes === true || Number(transmissao.indicacoes) === 1) ? atletaIndicacao?.idIndicacao ?? null : null
                            }
                            mensagemLoading('Gerando pix..')
                            criaPix(dados).then((res) => {
                                if (res.erro || !res.data) {
                                    mensagemErro(res.message || res.msg || 'Não foi possível gerar o Pix. Tente novamente.');
                                    return;
                                }
                                if (Number(res.data.indicacao || 0) !== Number(dados.indicacao || 0)) {
                                    setAtletaIndicacao(null);
                                    setMensagemIndicacao('Este Pix já havia sido gerado. A indicação original do pagamento foi mantida.');
                                }
                                setContador(res.data.minutosRestantes)
                                setQrcode(res.data.pagamento.qrcode)
                                setCopiaCola(res.data.pagamento.chave)
                                Swal.close()
                                startApiCalls(res.data.id, transmissao)
                                openModalPix()
                                const data = {
                                    idUsuario: user.id,
                                    acao: 'Gerou o pix da transmissão ' + transmissao.nome
                                }
                                auditoria(data);
                            }).catch(() => mensagemErro('Não foi possível gerar o Pix. Tente novamente.'))
                        }
                    });
                }
            }
        })
    }

    function cadastraSala() {
        if (!usuario.id) {
            mensagemAlerta('Selecione um usuário')
            return
        }
        Swal.fire({
            title: 'Aviso',
            text: `Deseja adicionar o usuário ${usuario.nome} como convidados desta transmissão ?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Cadastrando usuário a sala VIP')
                const user = JSON.parse(localStorage.getItem('userd7'))
                const data = {
                    idUsuario: usuario.id,
                    idSala: id,
                    tipo: 'transmissao',
                    idConvidado: user.id,
                }
                criaSalaVipConvidado(data).then((res) => {
                    if (res.erro) {
                        mensagemAlerta(res.msg)
                    } else {
                        mensagemSucessoSalaVip(res.message)
                    }
                })
            }
        });
    }

    function removeSala(item) {
        Swal.fire({
            title: 'Aviso',
            text: 'Deseja remover o usuário ' + item.usuarioNome + ' da sala VIP desta transmissão  ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Removendo usuário da sala VIP')
                const data = {
                    idUsuario: item.usuarioId,
                    idSala: id,
                    tipo: 'transmissao'
                }
                deletaSalaVip(data).then((res) => {
                    if (res.erro) {
                        mensagemErro('Erro ao cadastrar usuário na sala vip')
                    } else {
                        mensagemSucessoSalaVip('Usuário adicionado a sala vip com sucesso!')
                    }
                })
            }
        });
    }

    async function buscaIndicacaoAtleta(event) {
        event.preventDefault();
        if (buscandoIndicacao) return;
        setAtletaIndicacao(null);
        const cpfBusca = cpfIndicacao.replace(/\D/g, '');
        if (!cpf.isValid(cpfBusca)) {
            setMensagemIndicacao('Digite um CPF válido para buscar o atleta.');
            return;
        }
        const usuarioLogado = JSON.parse(localStorage.getItem('userd7'));
        if (cpfBusca === String(usuarioLogado?.cpf || '').replace(/\D/g, '')) {
            setMensagemIndicacao('Você não pode indicar a si mesmo.');
            return;
        }
        setBuscandoIndicacao(true);
        setMensagemIndicacao('');
        try {
            const res = await buscaAtletaIndicacaoEvento({ idTransmissao: transmissao.id, idUsuario: usuarioLogado?.id, cpf: cpfBusca });
            if (res.erro) {
                setMensagemIndicacao(res.message);
            } else {
                setAtletaIndicacao(res.atleta);
            }
        } catch (error) {
            setMensagemIndicacao('Não foi possível buscar o atleta. Tente novamente.');
        } finally {
            setBuscandoIndicacao(false);
        }
    }

    function veirificaCupom() {
        if (!cupom) {
            mensagemAlerta('Por favor digite o cupom')
            return
        }
        buscaCupom(cupom, id).then((res) => {
            if (res.erro) {
                mensagemAlerta(res.msg)
            } else {
                setDeconto(parseFloat(res.dados.valor))
                setIdCupom(res.dados.id)
                mensagemSucesso('Cupom de R$ ' + res.dados.valor + '  aplicado com sucesso!')
            }
        })
    }

    const extractFileIdGoogle = (url) => {
        const regex = /\/d\/(.*?)\//;  // Expressão regular para pegar o ID entre "/d/" e "/"
        const match = url.match(regex);
        return match ? match[1] : null;
    };

    const handleDownload = (urlVideo) => {
        if (!urlVideo) {
            alert('A URL do vídeo é necessária');
            return;
        }

        // Cria dinamicamente um link para fazer a requisição ao backend com a URL do vídeo
        const link = document.createElement('a');
        link.href = `https://app-3prv6jubba-uc.a.run.app/downloadVideo?url=${encodeURIComponent(urlVideo)}`;  // Envia a URL como query parameter

        // Força a abertura da janela de download
        link.target = '_blank';  // Abre o link em uma nova aba (alguns navegadores tratam isso como uma nova ação de download)
        link.download = '';      // O atributo download vazio forçará o diálogo de download para o usuário escolher onde salvar

        // Simula o clique no link para iniciar o download
        document.body.appendChild(link);
        link.click();

        // Remove o link do DOM após o clique
        document.body.removeChild(link);
    };

    function assitirVideo(item) {
        setUrlVideo(item)
        openModal()
    }

    const handleUsuario = (usuario, index) => {
        setUsuario(usuario);
    };

    const handleCupom = (event) => {
        event.persist();
        setCupom(event.target.value);
        if (event.target.value.length === 0) {
            setDeconto(0)
            setIdCupom('')
        }
    }

    // Mensagens
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }

    function mensagemErro(msg) {
        Swal.fire('Erro', msg, 'error')
    }
    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success')
    }

    function mensagemSucessoSalaVip(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            setSalaVip([])
            const user = JSON.parse(localStorage.getItem('userd7'))
            listaSalaVipConvidados(
                { idUser: user.id, idSala: id, tipo: 'transmissao' }
            ).then((res) => {
                if (res.erro) {
                    mensagemErro('Erro ao buscar usuarios')
                } else {
                    setSalaVip(res.convidados)
                }
            })
        })
    }

    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                {JSON.parse(localStorage.getItem('userd7'))?.perfil === 'ATLETA_PROFISSIONAL' && <Menu />}
                <div class="layout-page">
                    <div>
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 container-p-y">
                                <h3><b>{academia}</b></h3>
                                <button onClick={() => window.location = '/homeAtleta'} style={{ marginTop: 20, width: '30%' }} className="btn btn-primary d-grid " type="submit">{'< Voltar'}</button>
                                {!modalVideo ?
                                    <div className="col-sm-12 col-lg-12 mb-4" style={{ marginTop: 20 }}>
                                        <div className="card card-border-shadow-primary h-100">
                                            {transmissao && transmissao.id ?
                                                <div className="card-body" style={{ alignItems: 'center', textAlign: 'center' }}>
                                                    <img style={{ width: 200, height: 200 }} src={transmissao.urlImagem} />
                                                    <h2 style={{ marginTop: 20 }}>{transmissao.nome}</h2>
                                                    <h5>TERMOS DE ACEITE</h5>
                                                    <p>Versão : v3</p>
                                                    <div>{parse(termo)}</div>
                                                    <p>Valor para assistir esta transmissão</p>
                                                    {transmissao.free === 'SIM' ?
                                                        <h5 ><b>ESSA TRANSMISSÃO É GRATUITA</b></h5>
                                                        :
                                                        <h5 ><b>{(transmissao.valor - parseFloat(desconto)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</b></h5>
                                                    }

                                                    {desconto > 0 ?
                                                        <p style={{ color: 'green' }}>Cupom de {(parseFloat(desconto)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} aplicado</p>
                                                        :
                                                        null
                                                    }
                                                    {transmissao.free !== 'SIM' &&
                                                        <>
                                                            <div className="mb-3 col-md-12" style={{ textAlign: 'center' }}>
                                                                <label className="form-label" htmlFor="cupom-transmissao">Digite o cupom de desconto</label>
                                                                <input id="cupom-transmissao" value={cupom.toUpperCase()} onChange={handleCupom} type="text" className="form-control" />
                                                            </div>
                                                            <button onClick={() => veirificaCupom()} style={{ marginTop: 20 }} className="btn btn-info d-grid w-100" type="button">
                                                                <i className="menu-icon tf-icons bx bx-file" />Verificar Cupom
                                                            </button>
                                                        </>
                                                    }
                                                    {(transmissao.indicacoes === true || Number(transmissao.indicacoes) === 1) &&
                                                        <div className="border rounded p-3 mt-4" style={{ textAlign: 'left' }}>
                                                            <h5>Indicações por atleta</h5>
                                                            <p>Foi indicado por um atleta? Digite o CPF dele para buscar sua indicação neste evento.</p>
                                                            <form onSubmit={buscaIndicacaoAtleta}>
                                                                <div className="row align-items-end">
                                                                    <div className="mb-3 col-md-8">
                                                                        <label htmlFor="cpf-indicacao-evento" className="form-label">CPF do atleta</label>
                                                                        <InputMask
                                                                            id="cpf-indicacao-evento"
                                                                            name="cpfIndicacao"
                                                                            type="text"
                                                                            inputMode="numeric"
                                                                            mask="999.999.999-99"
                                                                            maskChar={null}
                                                                            placeholder="000.000.000-00"
                                                                            className="form-control"
                                                                            value={cpfIndicacao}
                                                                            disabled={buscandoIndicacao}
                                                                            onChange={(event) => {
                                                                                setCpfIndicacao(event.target.value);
                                                                                setAtletaIndicacao(null);
                                                                                setMensagemIndicacao('');
                                                                            }}
                                                                            aria-describedby={mensagemIndicacao ? 'mensagem-indicacao-evento' : undefined}
                                                                        />
                                                                    </div>
                                                                    <div className="mb-3 col-md-4">
                                                                        <button type="submit" className="btn btn-primary w-100" disabled={buscandoIndicacao}>
                                                                            {buscandoIndicacao ? 'Buscando...' : 'Buscar'}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                            {mensagemIndicacao && <p id="mensagem-indicacao-evento" className="mb-0" role="status">{mensagemIndicacao}</p>}
                                                            {atletaIndicacao &&
                                                                <div role="status">
                                                                    <p className="mb-1"><strong>Atleta encontrado: {atletaIndicacao.nome}</strong></p>
                                                                    <p className="mb-0">CPF: {String(atletaIndicacao.cpf).replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                    <button onClick={() => realizaTransmissao()} style={{ marginTop: 20 }} className="btn btn-success d-grid w-100" type="button">
                                                        <i className="menu-icon tf-icons bx bx-video" />Concordar e Assistir Transmissão
                                                    </button>

                                                </div>
                                                :
                                                null
                                            }

                                        </div>
                                    </div>
                                    :
                                    null
                                }
                                {modalVideo ?
                                    <div className="col-sm-12 col-lg-12 mb-4" style={{ marginTop: 20 }}>
                                        <div className="card card-border-shadow-primary h-100">
                                            {transmissao && transmissao.id ?
                                                <div className="card-body" style={{ alignItems: 'center' }}>
                                                    <div className='row'>
                                                        <div className='col-md-8'>

                                                            <iframe
                                                                width={isMobile ? "100%" : "100%"}
                                                                height={isMobile ? "100%" : "500px"}
                                                                src={getPlayerUrl(urlVideo)}
                                                                title="Transmissão"
                                                                frameBorder="0"
                                                                allowFullScreen
                                                                style={{
                                                                    border: 'none',
                                                                    ...(isMobile && {
                                                                        minHeight: "300px", // opcional para garantir altura mínima
                                                                    })
                                                                }}
                                                            ></iframe>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <h2 style={{ marginTop: 20 }}>{transmissao.nome}</h2>

                                                        </div>
                                                    </div>
                                                    {qtdConvidados > 0 ?
                                                        <div className='col-md-12'>
                                                            <h2 style={{ marginTop: 20 }}>Convidados - Limite de {qtdConvidados} convidados</h2>
                                                            <p>Adicione abaixo seus convidados. Você possui <b>{parseInt(qtdConvidados) - parseInt(salaVip.length)}</b> convidados para adicionar</p>
                                                            <div className="row">
                                                                <div class="mb-3 col-md-4">
                                                                    <label class="form-label" for="basic-icon-default-fullname">Usuários</label>
                                                                    <UsuarioSelect
                                                                        usuarios={usuarios}
                                                                        handleUsuarioSelecionado={handleUsuario}
                                                                    />
                                                                </div>
                                                                <div class="mb-3 col-md-3" style={{ marginTop: 30 }}>
                                                                    <button onClick={() => cadastraSala()} type="submit" className="btn btn-primary me-2">Adicionar</button>
                                                                </div>
                                                            </div>
                                                            <div className="table-responsive text-nowrap">
                                                                <table className="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Usuário</th>
                                                                            <th>Email</th>
                                                                            {/* <th>Remover</th> */}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="table-border-bottom-0">
                                                                        {salaVip.map((sala) =>
                                                                            <tr key={sala.id}>
                                                                                <td>{sala.usuarioNome}</td>
                                                                                <td>{sala.usuarioEmail}</td>
                                                                                {/* <td>
                                                                                    <button onClick={() => removeSala(sala)} type="button" className="btn rounded-pill btn-icon btn-danger">
                                                                                        <span className="tf-icons bx bx-trash" />
                                                                                    </button>
                                                                                </td> */}
                                                                            </tr>
                                                                        )}
                                                                        {salaVip.length === 0 ?
                                                                            <p style={{ textAlign: 'center', padding: 10 }} >Sem usuarios na sala vip</p>
                                                                            :
                                                                            null
                                                                        }

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                </div>
                                                :
                                                null
                                            }

                                        </div>
                                    </div>
                                    :
                                    null
                                }

                                {isModalOpen && urlVideo && <Modal onClose={closeModal} playerNumber={urlVideo} transmissao={transmissao} />}
                                {isModalOpenPix && <ModalPix textToCopy={copiaCola} qrcode={qrcode} onClose={closeModalPix} contador={contador} />}
                            </div>
                            <Footer />
                            <div className="content-backdrop fade" />
                        </div>
                        {/* Content wrapper */}
                    </div>
                </div>

            </div>
        </div>

    );
}